// removed by extract-text-webpack-plugin
module.exports = {"filename-wrapper":"filename-wrapper","filename-end":"filename-end","filename":"filename"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/FlexableFileName/flexableFileName.scss
// module id = 916
// module chunks = 0